import { Subject } from 'rxjs'

import { DrawerContentWidthVariant } from '@/presentation/modules/Base/components/Drawer/Drawer.types'
import { RouterPaths } from '@/presentation/router/RouterPathsMapper'

export type DrawerImperativeEvent = {
  type: 'open' | 'close' | 'set-content-width'
  screen?: RouterPaths
  stateLocation?: Record<string, string>
  variant?: DrawerContentWidthVariant
}

const DrawerImperativeSubject = new Subject<DrawerImperativeEvent>()

const DrawerImperativeInterface = {
  close: () => {
    DrawerImperativeSubject.next({ type: 'close' })
  },

  open: (screen: RouterPaths, stateLocation?: Record<string, string>) => {
    DrawerImperativeSubject.next({ type: 'open', screen, stateLocation })
  },

  setContentWidth: (variant: DrawerContentWidthVariant) => {
    DrawerImperativeSubject.next({ type: 'set-content-width', variant })
  }
}

export { DrawerImperativeInterface, DrawerImperativeSubject }
